import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardAppSharedService,
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto,
} from '../../services/wealthlane-award-services';
import { ParticipantHoldingDetailsService } from '../../services/wealthlane-award-services/services/ParticipantHoldingDetailsService';

const useGetParticipantHoldingDetailsV2 = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
  //   isOnBoarded?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto | undefined,
  unknown
> => {
  const participantHoldingDetailsV2 = useQuery(
    ['getParticipantHoldingDetailsV2'],
    async () => {
      //   if (isOnBoarded) {
      return await handleRequest(
        ParticipantHoldingDetailsService.getApiAwardApiAppDashboardParticipantHoldingDetailsV2()
      );
    }
    // }
  );
  return participantHoldingDetailsV2;
};

export default useGetParticipantHoldingDetailsV2;
